import { KeyInput } from 'Components/shared/inputs';
import React, { useMemo } from 'react';


const AuthCodeInput = ({numberOfChar=6,className,onChange,fullWidth,value, ...props}) => {


    const numArr = useMemo(()=> new Array(numberOfChar).fill(10),[numberOfChar]);

    const onKeydownHandler = (e) => {
        if((e.target.value.length < 1 || e.keyCode == 8) && ((e.keyCode > 47 && e.keyCode < 58) || (e.keyCode > 95 && e.keyCode < 106 ) || e.keyCode == 8)) return true;
        else if(e.keyCode == 13 || e.target.value.length >=1){
           const children =  e.target.parentNode.childNodes;
            const ind = Array.prototype.indexOf.call(children,e.target);
           
            if(ind === numberOfChar -1){
                e.stopPropagation();
                e.preventDefault();
            }
            else if(children[ind + 1].value.length < 1){

                children[ind + 1].click();
                children[ind + 1].focus();
            }
            else{
                    children[ind + 1].click();
                    children[ind + 1].focus();
                    e.stopPropagation();
                    e.preventDefault();
                    return false;  
            }
        }
        else{
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
       
    }
    const onChangeHandler = (e) => {
        const children =  e.target.parentNode.childNodes;
        const ind = Array.prototype.indexOf.call(children,e.target);
        numArr[ind] = e.target.value;
        let newArr = numArr.filter(num => num < 10);
        onChange?.(newArr.join('').trim());
    }
    const valueArr  = value?.toString()?.split("")?.slice(0,numberOfChar) || [];
    
    return(
        <div className={`row-start w-full ${className ? className : ""}`} style={{gap:"1rem",justifyContent:"space-between"}} {...props}>
        {
            numArr.map((_,ind) => {
                if(ind === 0) return  <KeyInput key={ind} onKeyDown={onKeydownHandler} autoFocus  onChange={onChangeHandler}  name={`keyInput-${ind}`}/>
                else return <KeyInput key={ind} onKeyDown={onKeydownHandler} onChange={onChangeHandler}  name={`keyInput-${ind}`} />
            })
        }
        
     </div>
    )
}

export default AuthCodeInput;